export enum MainSource {
  All = 'all',
  SiteFiles = 'private',
  MediaFromWix = 'public',
  Trash = 'trash',
  Favorites = 'favorites',
  VisitorsUploads = 'visitorsUploads',
  Recommended = 'custom',
  NTT = 'ntt',
  Shutterstock = 'shutterStock',
  ShutterstockVideo = 'shutterStockVideo',
  Unsplash = 'unsplash',
  Home = 'home',
  Boards = 'boards',
  Yell = 'yell',
  Enterprise = 'enterprise',
  MultiSearch = 'multiSearch',
}

export enum ExternalSource {
  Computer = 'computer',
  Facebook = 'facebook',
  Dribbble = 'dribble',
  GoogleDrive = 'drive',
  Dropbox = 'dropbox',
  Instagram = 'instagram',
  Flickr = 'flickr',
  DeviantArt = 'deviantArt',
  GooglePhotos = 'googlePhotos',
  WixSite = 'wixSite',
  WixVideo = 'wixVideo',
  Link = 'link',
  Vimeo = 'vimeo',
}

export enum OtherSource {
  External = 'external',
  Photostock = 'photoStock',
}

export const SupportedSourcesList = [
  MainSource.Home,
  MainSource.All,
  MainSource.SiteFiles,
  MainSource.MediaFromWix,
  MainSource.Trash,
  MainSource.Favorites,
  MainSource.Boards,
  MainSource.VisitorsUploads,
  MainSource.Recommended,
  MainSource.Shutterstock,
  MainSource.ShutterstockVideo,
  MainSource.Unsplash,
  MainSource.NTT,
  OtherSource.Photostock,
  OtherSource.External,
];

export const SupportedExternalSourcesList = [
  ExternalSource.Computer,
  ExternalSource.Facebook,
  ExternalSource.Dribbble,
  ExternalSource.GoogleDrive,
  ExternalSource.Dropbox,
  ExternalSource.Instagram,
  ExternalSource.Flickr,
  ExternalSource.DeviantArt,
  ExternalSource.GooglePhotos,
  ExternalSource.WixSite,
  ExternalSource.Link,
  ExternalSource.Vimeo,
];

export type Source = MainSource | ExternalSource | OtherSource;
